import type { TaggedInfos } from "@/apis/table/types";
import { tagKey as toTagKey } from "@/components/mapping/utils";

/**
 * 태그 일괄 제거 응답을 캐시에 반영한다. 응답에 담긴 주소의 셀에서만 해당 tagKey 를 뗀다.
 * 같은 셀에 붙은 다른 태그와 다른 셀은 그대로 둔다.
 */
export const dropTagFromCells = <
  T extends { address: string; taggedInfos: TaggedInfos },
>(
  cells: T[],
  removedAddresses: Set<string>,
  tagKey: string,
): T[] => {
  const next: T[] = [];
  for (const cell of cells) {
    if (!removedAddresses.has(cell.address)) {
      next.push(cell);
      continue;
    }
    const tags = [];
    for (const tag of cell.taggedInfos.tags) {
      if (tag.key !== tagKey) tags.push(tag);
    }
    next.push({ ...cell, taggedInfos: { ...cell.taggedInfos, tags } });
  }
  return next;
};

/** 셀별 태그 조회 응답(prefix·name 으로 표현된 태그)에서 tagKey 를 뗀다. */
export const dropTagFromTagInfos = <T extends { prefix: string; name: string }>(
  tags: T[],
  tagKey: string,
): T[] => {
  const next: T[] = [];
  for (const tag of tags) {
    if (toTagKey(tag.prefix, tag.name) !== tagKey) next.push(tag);
  }
  return next;
};
